import Text from "../text/Text";
import { IconButton } from "../button/Button";
import { Icon, type IconName } from "../icon/Icon";
import { type Component, Show } from "solid-js";
import ExpandClickArea from "../ExpandClickArea";

type ButtonProps = {
  onClick: () => void;
  "aria-label": string;
};
type DismissiblePillProps = {
  label: string;
  value: string;
  icon?: { name: IconName; colors?: string };
  actionButton: ButtonProps;
  closeButton: ButtonProps;
};

const DismissiblePill: Component<DismissiblePillProps> = (props) => (
  <div class="group flex w-fit max-w-100 items-stretch rounded-sm border border-subtle bg-surface-default focus-within:outline-default [&:has(:last-child:focus)]:outline-0 [&:not(:has([class*='bg-']:hover))]:hover:bg-surface-hover">
    <button {...props.actionButton} type="button" class="-my-px p-1.5 pr-1 focus:outline-none">
      <div class="grid grid-flow-col gap-1.5">
        <Show when={props.icon}>
          {(icon) => (
            <div
              class="inline-flex size-5 shrink-0 items-center justify-center rounded-sm"
              classList={{
                [icon().colors ?? ""]: true,
              }}
            >
              <Icon name={icon().name} size="sm" type="solid" />
            </div>
          )}
        </Show>

        <Text class="text-base-medium text-primary" text={props.label} truncate />
        <span class="-ml-1.5 text-base-medium text-primary">:</span>
        <Text class="text-base-regular text-primary" text={props.value} truncate />
      </div>
    </button>

    <ExpandClickArea class="-my-px -mr-px shrink-0">
      <IconButton {...props.closeButton} class="mr-1 ml-auto" icon="x" variant="tertiary" size="small" />
    </ExpandClickArea>
  </div>
);

export default DismissiblePill;
